import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { Switch, withRouter } from 'react-router-dom';
import CookieNotification from '@client/components/cookieNotification/CookieNotification';
import Footer from '@client/containers/appFrame/footer/Footer';
import GenericHelmet from '@client/helperComponents/genericHelmet/GenericHelmet';
import routes, { ROUTES } from '@client/pages/routes';
import { routeWithSubRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import styles from './appFrame.scss';
import ErrorBoundary from './errorBoundary/ErrorBoundary';
import MainHeader from './mainHeader/MainHeader';

const ACCEPT_COOKIES = 'acceptCookies';

const MainRouteSwitch = withRouter(() => {
  function getMainClassName() {
    return classNames({
      [styles.main]: true,
    });
  }

  return (
    <main className={getMainClassName()}>
      <Switch>
        {routes.map((route, index) => routeWithSubRoutes(route, index))}
      </Switch>
    </main>
  );
});

class AppFrame extends PureComponent {
  constructor(props) {
    super(props);
    const acceptCookies = props.cookies.get(ACCEPT_COOKIES);
    this.state = {
      acceptCookies: acceptCookies,
    };
  }

  handleAcceptCookies = () => {
    this.setState(
      () => {
        return {
          acceptCookies: true,
        };
      },
      () => {
        const expiryDate = new Date();
        expiryDate.setFullYear(2037);
        const cookieOptions = {
          path: '/',
          expires: expiryDate,
        };

        this.props.cookies.set(ACCEPT_COOKIES, 'true', cookieOptions);
      }
    );
  };

  // scroll to top on history change
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      if (
        location.pathname !== ROUTES.contact &&
        location.pathname !== ROUTES.about
      ) {
        window.scrollTo(0, 0);
      }
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <GenericHelmet />
        <div className={styles.appFrame} id="app-container">
          <MainHeader />
          <div className={styles.mainContentBelowHeader}>
            <MainRouteSwitch />
          </div>
          {!this.state.acceptCookies && (
            <CookieNotification onAcceptCookies={this.handleAcceptCookies} />
          )}
          <Footer />
        </div>
      </ErrorBoundary>
    );
  }
}

AppFrame.propTypes = {
  location: PropTypes.object,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

export default withRouter(withCookies(AppFrame));
